export default [
    { title: "Despacho nacional" },
    { title: "Despacho internacional" },
    { title: "Empresa" },
    { title: "Headhunter" },
   

    
  ];